<template>
	<v-data-table
	    :headers="headers"
	    :items="$store.state.notifications"
	    class="elevation-1"      
	    :search="search"
	>
    	<template v-slot:body="{ items }">
  			<tbody>
        		<tr v-for="item in items" :key="item.id">
        			<td class="text-xs-left">{{item.store.name}}</td>
					<td class="text-xs-left">        				
        				{{item.payment_id}}
        			</td>
        			<td class="text-xs-left">        				
        				{{item.status.status}}
        			</td>
        			<td style="max-width: 300px; word-wrap: break-word;" class="text-xs-left">{{item.notification}}</td>
        			<td>
						<v-btn @click="remove(item.id)" title="Remover mensagem" fab dark small color="error">
							<v-icon dark>remove</v-icon>
						</v-btn>
						<v-btn @click="$emit('edit', item)" fab dark small color="cyan">
							<v-icon dark>edit</v-icon>
						</v-btn>
					</td>
        		</tr>
    		</tbody>
		</template>
	</v-data-table>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default () {
				return [];
			}
		},
	},
	name: 'List',
	created() {
		this.$store.dispatch('fetchNotifications');
	},
	methods: {
		remove(data) {
			if (
				confirm('Tem certeza que quer deletar esta mensagem?')
			) {
				this.$store.dispatch('deleteNotification', {params: {id: data}})
			}
		},		
	},
	data () {
    	return {
    		search: '',
			headers: [
				{text: 'Loja/Produto', value: 'store.name'},
				{text: 'Pagamento', value: 'payment_id'},
				{text: 'Status', value: 'status.status'},
				{text: 'Notificação', value: 'notification'},
				{text: '', value: ''}
        	],
    	}
	}
}
</script>

<style lang="css" scoped>
</style>